var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_page"},[_c('div',[_vm._v("品牌详情")]),_c('div',[_vm._v("品牌详情")]),_c('div',[_vm._v("品牌详情")])])
}]

export { render, staticRenderFns }